export default __webpack_public_path__ + "static/media/13.bfd3b265.png";